import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { PageHeader, PageSection } from '@gik/ui';
import MarketingNavSection from '../../components/MarketingNav/MarketingNavSection';
import { StartInkindContent } from '@gik/ui/gik/StartInkindCard';
import BenefitsHero from '../../components/BenefitsHero';
import { BenefitsListSection } from '../../components/BenefitsList';
import { InkindUsesSection } from '@gik/marketing/components/InkindUses';
import WhySupportMattersSection from '@gik/marketing/components/WhySupportMatters';
import TestimonialsCarouselSection from '@gik/ui/gik/TestimonialsCarouselSection';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import { CreateClickedLocation } from '@gik/create/hooks/useCreateAnalytics';

export default function BenefitsPage(): React.ReactElement {
  const bem = bemBlock('benefits-page');
  const { t } = useTranslation();
  return (
    <div className={bem()}>
      <PageHeader variant="purps" decoration="foliage">
        <h1>{t(translationKeys.title)}</h1>
      </PageHeader>

      <PageSection className={bem('lead')} noPadBottom>
        <p className="gik-section-lead">{t(translationKeys.leadDescription)}</p>
      </PageSection>
      <br className="base" />
      <PageSection noPadTop>
        <BenefitsHero />
      </PageSection>

      <BenefitsListSection />

      <InkindUsesSection cols={4} perPage={4} />

      <WhySupportMattersSection />

      <TestimonialsCarouselSection />

      <PageSection noPadTop>
        <StartInkindContent trackingId={CreateClickedLocation.BENEFITS_PAGE} />
      </PageSection>
      <MarketingNavSection variant="purps" />
    </div>
  );
}
